/* ============================================================================
   Furniva — Offers & EMI, live from Razorpay (product page).

   The row under the price asks the account Worker's /api/offers for the price
   on screen; the Worker asks Razorpay (its public affordability endpoint) and
   returns the live bank offers and the EMI plans this price qualifies for,
   with the real monthly figures (apps/account-worker/src/lib/offers.js).
   Nothing here is typed in by hand, and no key or secret lives in the theme.

   Cards, in order: No Cost EMI (only if Razorpay has such a plan), Easy EMI
   ("Get it for ₹352/m", three bank logos and "+13"), each live bank offer,
   Pay Later and Cardless EMI when available. A card opens the dialog with
   every bank's plans. If Razorpay cannot be reached, the row is removed —
   never left showing a promise that could be stale.

   Owner direction, 2026-09-30: our design, not Razorpay's widget.
   ============================================================================ */
(function () {
  'use strict';

  var strip = document.querySelector('[data-fv-offers-strip]');
  if (!strip) return;
  var row = strip.querySelector('[data-fv-offers-row]');
  var endpoint = strip.getAttribute('data-endpoint');
  var detail = document.querySelector('[data-fv-offers-detail]');
  var empty = document.querySelector('[data-fv-offers-empty]');
  var lastAmount = null;
  var data = null;

  var inr = function (paise) {
    return '₹' + Math.round(paise / 100).toLocaleString('en-IN');
  };
  function el(tag, cls, text) {
    var node = document.createElement(tag);
    if (cls) node.className = cls;
    if (text != null) node.textContent = text;
    return node;
  }
  function logos(banks, max) {
    var wrap = el('span', 'fv-ocard__logos');
    // One mark per bank: HDFC's credit and debit plans share a logo.
    var seen = {};
    banks = banks.filter(function (bank) {
      if (seen[bank.logo]) return false;
      seen[bank.logo] = true;
      return true;
    });
    banks.slice(0, max).forEach(function (bank) {
      var img = el('img');
      img.src = bank.logo;
      img.alt = bank.name;
      img.width = 22;
      img.height = 22;
      img.loading = 'lazy';
      img.referrerPolicy = 'no-referrer';
      img.onerror = function () { img.remove(); };
      wrap.appendChild(img);
    });
    if (banks.length > max) wrap.appendChild(el('span', 'fv-ocard__more', '+' + (banks.length - max)));
    return wrap;
  }
  function card(title, body, extra, view) {
    var node = el('button', 'fv-ocard');
    node.type = 'button';
    node.setAttribute('data-fv-offers-open', '');
    node.setAttribute('aria-haspopup', 'dialog');
    node.setAttribute('aria-controls', 'fv-offers');
    var head = el('span', 'fv-ocard__head');
    head.appendChild(el('span', 'fv-ocard__title', title));
    var arrow = el('span', 'fv-ocard__go');
    arrow.setAttribute('aria-hidden', 'true');
    head.appendChild(arrow);
    node.appendChild(head);
    var bodyNode = el('span', 'fv-ocard__body');
    if (typeof body === 'string') bodyNode.textContent = body;
    else bodyNode.appendChild(body);
    node.appendChild(bodyNode);
    if (extra) node.appendChild(extra);
    node.addEventListener('click', function () { paintDetail(view); });
    return node;
  }
  function per(amount) {
    var frag = document.createDocumentFragment();
    frag.appendChild(document.createTextNode('Get it for '));
    frag.appendChild(el('strong', null, inr(amount) + '/m'));
    return frag;
  }

  function paintRow(payload) {
    Array.prototype.slice.call(row.querySelectorAll('.fv-ocard:not(.fv-ocard--manual)')).forEach(function (n) { n.remove(); });
    var cards = [];
    var emi = payload.emi;
    if (emi && emi.noCost) {
      var ncBanks = emi.banks.filter(function (b) { return emi.noCost.banks.indexOf(b.code) > -1; });
      cards.push(card('No Cost EMI', per(emi.noCost.from.monthly), logos(ncBanks, 3), 'nocost'));
    }
    if (emi && emi.from) cards.push(card('Easy EMI', per(emi.from.monthly), logos(emi.banks, 3), 'emi'));
    (payload.offers || []).filter(function (o) { return o.eligible; }).forEach(function (offer) {
      var body = offer.saving ? 'Save ' + inr(offer.saving) : (offer.text || 'On eligible payments');
      var extra = offer.logo ? logos([{ logo: offer.logo, name: offer.title }], 1) : null;
      cards.push(card(offer.title, body, extra, 'offers'));
    });
    if ((payload.paylater || []).length) cards.push(card('Pay Later', payload.paylater.slice(0, 2).join(', ') + (payload.paylater.length > 2 ? ' and more' : ''), null, 'emi'));
    if ((payload.cardless || []).length) cards.push(card('Cardless EMI', payload.cardless.slice(0, 2).join(', ') + (payload.cardless.length > 2 ? ' and more' : ''), null, 'emi'));

    row.querySelectorAll('.fv-ocard--skeleton').forEach(function (n) { n.remove(); });
    if (!cards.length && !row.querySelector('.fv-ocard--manual')) { strip.hidden = true; return; }
    var first = row.firstChild;
    cards.forEach(function (c) { row.insertBefore(c, first); });
    strip.hidden = false;
    strip.classList.add('is-ready');
  }

  function paintDetail(view) {
    if (!detail || !data) return;
    detail.replaceChildren();
    // The No Cost EMI card opens on its own plans only: the banks that have
    // one, and only their no-cost months (owner, 2026-10-01). Everything
    // else is one tap away.
    var noCostOnly = view === 'nocost' && data.emi && data.emi.noCost;
    var offers = noCostOnly ? [] : (data.offers || []).filter(function (o) { return o.eligible; });
    if (offers.length) {
      var box = el('div', 'fv-oplans__group');
      box.appendChild(el('span', 'fv-oplans__label', 'Offers on this price'));
      offers.forEach(function (o) {
        var line = el('div', 'fv-oplans__offer');
        line.appendChild(el('strong', null, o.title + (o.saving ? ' · save ' + inr(o.saving) : '')));
        if (o.text) line.appendChild(el('span', null, o.text));
        box.appendChild(line);
      });
      detail.appendChild(box);
    }
    if (data.emi) {
      var group = el('div', 'fv-oplans__group');
      group.appendChild(el('span', 'fv-oplans__label', (noCostOnly ? 'No Cost EMI on ' : 'EMI on ') + inr(data.amount)));
      var chips = el('div', 'fv-oplans__banks');
      chips.setAttribute('role', 'tablist');
      var table = el('div', 'fv-oplans__table');
      function show(bank, chip) {
        chips.querySelectorAll('button').forEach(function (b) { b.setAttribute('aria-selected', b === chip ? 'true' : 'false'); });
        table.replaceChildren();
        var head = el('div', 'fv-oplans__row fv-oplans__row--head');
        ['Months', 'Interest', 'Per month', 'Total'].forEach(function (t) { head.appendChild(el('span', null, t)); });
        table.appendChild(head);
        bank.plans.filter(function (plan) { return !noCostOnly || plan.noCost; }).forEach(function (plan) {
          var line = el('div', 'fv-oplans__row');
          line.appendChild(el('span', null, plan.months + ''));
          line.appendChild(el('span', plan.noCost ? 'is-free' : null, plan.noCost ? 'No cost' : plan.rate + '% p.a.'));
          line.appendChild(el('strong', null, inr(plan.monthly)));
          // No cost means the price, exactly: the monthly figure is rounded
          // up to the rupee, and six of them must not read ₹3 over.
          line.appendChild(el('span', null, inr(plan.noCost ? data.amount : plan.monthly * plan.months)));
          table.appendChild(line);
        });
      }
      var banks = noCostOnly
        ? data.emi.banks.filter(function (b) { return b.plans.some(function (p) { return p.noCost; }); })
        : data.emi.banks;
      banks.forEach(function (bank, i) {
        var chip = el('button', 'fv-oplans__bank');
        chip.type = 'button';
        chip.setAttribute('role', 'tab');
        var img = el('img');
        img.src = bank.logo; img.alt = ''; img.width = 18; img.height = 18; img.referrerPolicy = 'no-referrer';
        img.onerror = function () { img.remove(); };
        chip.appendChild(img);
        chip.appendChild(document.createTextNode(bank.name.replace(/ Bank$/, '')));
        chip.addEventListener('click', function () { show(bank, chip); });
        chips.appendChild(chip);
        if (i === 0) window.requestAnimationFrame(function () { show(bank, chip); });
      });
      group.appendChild(chips);
      group.appendChild(table);
      group.appendChild(el('p', 'fv-oplans__note', noCostOnly
        ? 'You pay ' + inr(data.amount) + ' in all: the interest comes off as an instant discount when you pay by EMI on an eligible card. Your bank confirms the plan at payment.'
        : 'Figures are Razorpay’s for this price, before any bank charges. Your bank confirms the plan at payment.'));
      if (noCostOnly) {
        var all = el('button', 'fv-oplans__all', 'See every EMI plan');
        all.type = 'button';
        all.addEventListener('click', function () { paintDetail('emi'); });
        group.appendChild(all);
      }
      if (view === 'offers' && offers.length) detail.appendChild(group);
      else detail.insertBefore(group, detail.firstChild);
    }
    detail.hidden = false;
    if (empty) empty.hidden = true;
  }

  function amountNow() {
    var price = document.querySelector('[data-fv-price][data-fv-amount]');
    return price ? parseInt(price.getAttribute('data-fv-amount'), 10) : NaN;
  }

  function load() {
    var amount = amountNow();
    if (!endpoint || !isFinite(amount) || amount <= 0 || amount === lastAmount) return;
    lastAmount = amount;
    fetch(endpoint, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ amount: amount })
    })
      .then(function (response) { return response.ok ? response.json() : null; })
      .then(function (payload) {
        if (!payload || !payload.ok) throw new Error('offers');
        data = payload;
        paintRow(payload);
      })
      .catch(function () {
        row.querySelectorAll('.fv-ocard--skeleton').forEach(function (n) { n.remove(); });
        if (!row.querySelector('.fv-ocard')) strip.hidden = true;
      });
  }

  load();
  // A finish with a different price swaps the price element (furniva-product.js).
  var box = strip.parentElement;
  if (box && typeof MutationObserver === 'function') {
    new MutationObserver(load).observe(box, { childList: true, subtree: true });
  }

  // Tap the code to copy it.
  document.addEventListener('click', function (event) {
    var code = event.target.closest && event.target.closest('[data-fv-copy]');
    if (!code) return;
    var text = code.getAttribute('data-fv-copy');
    var done = function () {
      code.classList.add('is-copied');
      window.setTimeout(function () { code.classList.remove('is-copied'); }, 1600);
    };
    if (navigator.clipboard && navigator.clipboard.writeText) navigator.clipboard.writeText(text).then(done, function () {});
  });
})();
